var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"logo--mylight",attrs:{"alt":"Mylight Systems","src":require("@/assets/images/tenants/myLight/logoWithText.svg")}})
}
var staticRenderFns = []

export { render, staticRenderFns }